import ProductsCombo from '@/widgets/ProductsCombo'

function BookingDetails({
	formState,
	formError,
	onSubmit,
	onFieldChange,
	onServiceChange,
	onProductSelect,
	onCancel,
	creating,
	resources = [],
	mode = 'create',
}) {
	const isEditMode = mode === 'edit'
	const primaryLabel = isEditMode ? 'Save changes' : 'Create booking'
	const busyLabel = isEditMode ? 'Saving...' : 'Creating booking...'
	return (
		<section>
			<div className="mb-3">
				<h3 className="text-base font-semibold text-gray-900">Booking details</h3>
				<p className="text-sm text-gray-500">Fill in the timing and notes for the booking.</p>
			</div>
			<form onSubmit={onSubmit} className="space-y-5">
				<div>
					<label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="booking-title">
						Booking title
					</label>
					<input
						id="booking-title"
						type="text"
						value={formState.title}
						onChange={e => onFieldChange('title', e.target.value)}
						placeholder="Optional title (will use customer name if left blank)"
						className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
					/>
				</div>

				<div>
					<label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="booking-service">
						Service
					</label>
					<ProductsCombo
						selectedId={formState.productId || ''}
						selectedProductName={formState.service || ''}
						onChange={onProductSelect}
					/>
				</div>

				<div>
					<label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="booking-resource">
						Resource
					</label>
					<select
						id="booking-resource"
						value={formState.resourceId}
						onChange={onServiceChange}
						disabled={resources.length === 0}
						className="w-full rounded-lg border border-gray-300 px-3 py-2 bg-white focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500">
						{resources.length === 0 && <option value="">No resources available</option>}
						{resources.map(resource => {
							const rid = String(resource._id ?? resource.id ?? '')
							return (
								<option key={rid} value={rid}>
									{resource.name}
								</option>
							)
						})}
					</select>
				</div>

				<div className="grid grid-cols-1 gap-4 md:grid-cols-2">
					<div>
						<label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="booking-start">
							Start time *
						</label>
						<input
							id="booking-start"
							type="datetime-local"
							value={formState.start}
							onChange={e => onFieldChange('start', e.target.value)}
							className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
						/>
					</div>
					<div>
						<label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="booking-end">
							End time *
						</label>
						<input
							id="booking-end"
							type="datetime-local"
							value={formState.end}
							onChange={e => onFieldChange('end', e.target.value)}
							className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
						/>
					</div>
				</div>

				<div>
					<label className="block text-sm font-medium text-gray-700 mb-1" htmlFor="booking-notes">
						Notes
					</label>
					<textarea
						id="booking-notes"
						rows={3}
						value={formState.notes}
						onChange={e => onFieldChange('notes', e.target.value)}
						className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
						placeholder="Optional instructions"
					/>
				</div>

				{formError && <p className="text-sm text-red-600">{formError}</p>}

				<div className="flex flex-col gap-3 sm:flex-row sm:justify-end">
					<button
						type="button"
						onClick={onCancel}
						className="rounded-md border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50">
							Cancel
						</button>
					<button
						type="submit"
						disabled={creating}
						className={`rounded-md px-4 py-2 text-sm font-semibold text-white shadow-sm focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${
							creating ? 'bg-indigo-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-500'
						}`}
					>
						{creating ? busyLabel : primaryLabel}
					</button>
				</div>
			</form>
		</section>
	)
}

export default BookingDetails
